module.exports = __webpack_public_path__ + "img/icon-hide-group-1.86f54494.svg";